module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0066.jpg?v=6f18484f";